import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button } from 'antd';
import { Input } from 'valuelink/lib/tags';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorSpecializations,
  deleteSpecialization,
  updateSpecialization,
} from '../../services';

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const SpecializationRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const SpecializationNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const SpecializationInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const SpecializationText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorSpecializationsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      specializations: [],
      doctorSpecializationId: null,
      title: '',
      specialist: '',
      specialistType: '',
      specialistDefinition: '',
      commonName: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchSpecialization();
  };

  componentDidUpdate = () => {
    if (document.getElementById('edit-form')) {
      document.getElementById('edit-form').scrollIntoView();
    }
  };

  fetchSpecialization = () => {
    const { dispatch } = this.props;
    fetchDoctorSpecializations(this.doctorId).then(res => {
      const specializations = res.data;
      dispatch(setDoctorProfile({ specializations }));
      this.setState({
        specializations,
      });
    });
  };

  submit = () => {
    const {
      doctorSpecializationId,
      title,
      specialist,
      specialistType,
      specialistDefinition,
      commonName,
    } = this.state;

    updateSpecialization({
      doctorId: this.doctorId,
      doctorSpecializationId,
      title,
      specialist,
      specialistType,
      specialistDefinition,
      commonName,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchSpecialization();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteSpecialization = doctorSpecializationId => {
    deleteSpecialization(this.doctorId, doctorSpecializationId)
      .then(() => {
        message.success('Specialization deleted successfully');
        this.fetchSpecialization();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editSpecialization = edu => {
    this.setState({
      formEditing: true,
      doctorSpecializationId: edu.doctorSpecializationId,
      title: edu.title || '',
      specialist: edu.specialist || '',
      specialistType: edu.specialistType || '',
      specialistDefinition: edu.specialistDefinition || '',
      commonName: edu.commonName || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorSpecializationId: null,
      title: '',
      specialist: '',
      specialistType: '',
      specialistDefinition: '',
      commonName: '',
    });
  };

  render() {
    const { specializations } = this.state;
    const titleLink = Link.state(this, 'title');
    const specialistLink = Link.state(this, 'specialist');
    const specialistTypeLink = Link.state(this, 'specialistType');
    const specialistDefinitionLink = Link.state(this, 'specialistDefinition');
    const commonNameLink = Link.state(this, 'commonName');

    const specializationsForm = () => {
      console.log({ state: this.state });
      return (
        <SpecializationRow id="edit-form">
          <BodyContainer>
            <LabelText>Specialization Title</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={titleLink}
              placeholder="Title"
            />

            <LabelText>Specialist</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={specialistLink}
              placeholder="Specialist"
            />

            <LabelText>Specialist Type</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={specialistTypeLink}
              placeholder="Specialist Type"
            />

            <LabelText>Specialist Definition</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={specialistDefinitionLink}
              placeholder="Specialist Definition"
            />

            <LabelText>Common Name</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={commonNameLink}
              placeholder="Common Name"
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10, marginTop: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button style={{ marginTop: 10 }} onClick={this.cancelEditing}>
                Cancel
              </Button>
            </EduRowComponent>
          </BodyContainer>
        </SpecializationRow>
      );
    };

    const renderSpecialization = (edu, idx) => (
      <SpecializationRow>
        <EduRowComponent>
          <SpecializationNumber>{idx + 1}. </SpecializationNumber>
          <SpecializationInfo>
            <SpecializationText>{edu.title}</SpecializationText>
            <SpecializationText>
              {`${edu.specialist}, ${edu.commonName}`}
            </SpecializationText>
          </SpecializationInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editSpecialization(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this?"
            onConfirm={() =>
              this.deleteSpecialization(edu.doctorSpecializationId)
            }
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </SpecializationRow>
    );

    return (
      <OuterContainer>
        <TitleText>Doctor Specialization Screen</TitleText>
        <ColContainer>{specializations.map(renderSpecialization)}</ColContainer>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editSpecialization({})}
          >
            Add Specialization
          </Button>
        )}
        {this.state.formEditing && specializationsForm()}
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorSpecializationsScreen);
